import {ClientPermissionPage, type ClientPermissionPageData} from "@/types/permissions/client-permission-pages";

export class BussinessLine {
    public id: number | null;
    public name: string;
    public value: string;
    public sort_order: number;
    public clientPermissionPages: ClientPermissionPage[];

    constructor(data: BussinessLineData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.name = "";
            this.value = "";
            this.sort_order = 0;
            this.clientPermissionPages = [];
        } else {
            this.id = data.id;
            this.name = data.name;
            this.value = data.value;
            this.sort_order = data.sort_order;
            this.clientPermissionPages = [];
            if (data.clientPermissionPages !== undefined) {
                data.clientPermissionPages.forEach(clientPermissionPage => this.clientPermissionPages.push((new ClientPermissionPage(clientPermissionPage))));
            }
        }
    }

    serializeData(): BussinessLineData {
        const bussiness_line_data: BussinessLineData = {
            id: this.id,
            name: this.name,
            value: this.value,
            sort_order: this.sort_order,
            clientPermissionPages: [],
        }

        return bussiness_line_data;
    }

    public resetToDefaults(): void {
        this.id = null;
        this.name = "";
        this.value = "";
        this.sort_order = 0;
        this.clientPermissionPages = [];
    }
}

export type BussinessLineData = {
    id: number | null;
    name: string;
    value: string;
    sort_order: number;
    clientPermissionPages: ClientPermissionPageData[] | undefined;
}
